<template>
<transition name="fade">
<div class="nav-fix" v-show="showFixNav">
  <div class="container">
    <div class="columns is-gapless is-mobile">
      <div class="column is-half-desktop left" v-if="!isMobile">
        <a href="http://www.geekbang.org" target="_blank">
          <img src="./assets/logo1.png" alt="">
          <span class="line"></span>
          <span class="title">企业服务</span>
        </a>
      </div>
      <div class="tab column is-half-desktop right">
        <div class="word">
          <span :class="{'active':currentIndex===0}" @click="switchItem(0)"><b>整合营销</b></span>
          <span :class="{'active':currentIndex===1}" @click="switchItem(1)"><b>培训和咨询</b></span>
        </div>
      </div>
    </div>
  </div>
</div>
</transition>
</template>
<script>
import { mapState } from 'vuex'
import bus from '@/util/vueBus'
export default {
  data () {
    return {
      scrollY: 0,
      currentIndex: 0
    }
  },
  computed: {
    showFixNav () {
      const value = this.scrollY > this.divT
      bus.$emit('showFixFooter', value)
      return value
    },
    ...mapState({
      isMobile: 'isMobile',
      divT: 'divT'
    })
  },
  mounted () {
    this.scrollY = window.scrollY
    window.addEventListener('scroll', (e) => {
      this.scrollY = window.scrollY
    })
  },
  props: [],
  components: {},
  methods: {
    switchItem (idx) {
      this.$emit('switch', idx)
      this.currentIndex = idx
      window.document.documentElement.scrollTop = window.document.body.scrollTop = this.divT + 1
      // var timer = setInterval(() => {
      //   var osTop = window.document.documentElement.scrollTop || window.document.body.scrollTop
      //   var ispeed = Math.floor(-osTop / 5)
      //   window.document.documentElement.scrollTop = window.document.body.scrollTop = osTop + ispeed
      //   if (osTop < this.divT + 160 || osTop < this.divT + 160) {
      //     clearInterval(timer)
      //   }
      // }, 30)
    }
  }
}
</script>
<style scoped lang="sass">
@import "../../../style/variable.sass"

$primary: #f66644

.fade-enter-active, .fade-leave-active
  transition: opacity 0.3s
.fade-enter, .fade-leave-to
  opacity: 0

.nav-fix
  height: 60px
  position: fixed
  z-index: 10
  width: 100%
  top: 0
  left: 0
  background-color: #fff
  border-bottom: 1px solid #e8e8e8
  +mobile
    height: 48px
  .container
    width: 80vw
    +mobile
      width: 90vw
    .columns
      align-items: stretch
      justify-content: space-between
      height: 60px
      +mobile
        height: 48px
    .column
      display: flex
      align-items: center
    .left
      flex-grow: 0
      flex-shrink: 0
      flex-basis: auto
      position: relative
      a
        position: relative
        img
          width: 38%
          vertical-align: middle
          +mobile
            width: auto
        span.title
          color: #a9a7a3
          font-weight: 700
          font-size: 18px
          padding-left: 20px
        span.line
          position: absolute
          top: 8px
          width: 2px
          height: 18px
          display: inline-block
          margin: 0 9px
          background-color: #a9a7a3
    .right
      +mobile
        justify-content: center
      .word
        display: flex
        justify-content: space-between
        align-items: center
        width: 200px
        transform: translateX(-90px)
        +mobile
          transform: translateX(0)
        span
          font-size: 18px
          cursor: pointer
          height: 60px
          display: flex
          align-items: center
          +mobile
            height: 48px
          b
            font-weight: 400
        span.active
          color: $primary !important
          border-bottom: 1px solid $primary
        span.line
          width: 1px
          height: 16px
          display: inline-block
          background-color: #a9a7a3
</style>
